import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAronChat } from "../hooks/useAronChat";
import { useAronTabSignals } from "../hooks/useAronTabSignals";
import { AronChatView } from "../components/AronChatView";
import { AronWorkbench } from "../components/workbench/AronWorkbench";
import { useAronUiStore } from "../store/aronUiStore";

/**
 * DLC_03 / ARON — full-page view, laid out like an editor: conversations open as
 * TABS, tabs sit in groups you can split, resize, maximise, tear off into a
 * separate window or into the global side dock. Everything lives in
 * AronWorkbench; this page only picks between it and the "popout" mode — one
 * conversation, no chrome, for a conversation dragged out into its own window.
 */
export function AronPage() {
  const [params] = useSearchParams();
  const closeDock = useAronUiStore((s) => s.closeDock);
  const dockOpen = useAronUiStore((s) => s.dockOpen);
  // Wejście na pełny widok ARON-a gasi pływające okno: inaczej po cofnięciu ze
  // strony obiektu ta sama rozmowa wisi w dwóch miejscach naraz i nie wiadomo,
  // w które pisać (zgłoszenie właściciela 2026-08-23).
  useEffect(() => {
    if (dockOpen) closeDock();
    // celowo raz przy wejściu na stronę — nie przy każdej zmianie stanu doku
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (params.get("popout") === "1") return <AronPopout />;
  return <AronWorkbench />;
}

/** One conversation filling the window — what "Otwórz w nowym oknie" opens. */
function AronPopout() {
  const [params, setParams] = useSearchParams();
  const convId = params.get("c");
  const select = (id: string | null) => {
    setParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        if (id) next.set("c", id);
        else next.delete("c");
        return next;
      },
      { replace: true },
    );
  };
  const { sending, handleSend, handleStop } = useAronChat(convId, select);
  // Visible window → no background badge, but a write proposal still gates.
  useAronTabSignals(convId, true);

  return (
    <div className="-mx-4 -my-4 flex h-[calc(100dvh-3.5rem)] flex-col overflow-hidden lg:-mx-6 lg:-my-6">
      <AronChatView
        conversationId={convId}
        sending={sending}
        onSend={handleSend}
        onStop={handleStop}
      />
    </div>
  );
}
